import { render, staticRenderFns } from "./TaxListFilter.vue?vue&type=template&id=12fc35f4&"
import script from "./TaxListFilter.vue?vue&type=script&lang=js&"
export * from "./TaxListFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports